var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',[_c('el-tooltip',{staticClass:"item",attrs:{"effect":"dark","content":_vm.$t(_vm.content),"placement":"top"}},[_c('copy-value',{attrs:{"val":_vm.val}},[_c('span',{staticClass:"cursor"},[_vm._v(_vm._s(_vm.val))])])],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4d0435d8","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/common/clickCopy.vue
// module id = null
// module chunks = 